import {
    MobileGoogle,
    MobileGoogle2x,
    DesktopGoogle,
    DesktopGoogle2x,
    MobileFacebook,
    MobileFacebook2x,
    DesktopFacebook,
    DesktopFacebook2x,
    MobileNetflix,
    MobileNetflix2x,
    DesktopNetflix,
    DesktopNetflix2x,
    MobilePaypal,
    MobilePaypal2x,
    DesktopPaypal,
    DesktopPaypal2x,
    MobilePG,
    MobilePG2x,
    DesktopPG,
    DesktopPG2x
} from './images_config';

export const COMPANY_LOGOS = [
    {
        alt: 'facebook',
        src: DesktopFacebook,
        mobile: `${MobileFacebook} 1x, ${MobileFacebook2x} 2x`,
        desktop: `${DesktopFacebook} 1x, ${DesktopFacebook2x} 2x`
    },
    {
        alt: 'Google',
        src: DesktopGoogle,
        mobile: `${MobileGoogle} 1x, ${MobileGoogle2x} 2x`,
        desktop: `${DesktopGoogle} 1x, ${DesktopGoogle2x} 2x`
    },
    {
        alt: 'NETFLIX',
        src: DesktopNetflix,
        mobile: `${MobileNetflix} 1x, ${MobileNetflix2x} 2x`,
        desktop: `${DesktopNetflix} 1x, ${DesktopNetflix2x} 2x`
    },
    {
        alt: 'P&G',
        src: DesktopPG,
        mobile: `${MobilePG} 1x, ${MobilePG2x} 2x`,
        desktop: `${DesktopPG} 1x, ${DesktopPG2x} 2x`
    },
    {
        alt: 'PayPal',
        src: DesktopPaypal,
        mobile: `${MobilePaypal} 1x, ${MobilePaypal2x} 2x`,
        desktop: `${DesktopPaypal} 1x, ${DesktopPaypal2x} 2x`,
        displayFromSm: true
    }
];

export const MOBILE_IMAGE = '(max-width: 899px)';

export const DESKTOP_IMAGE = '(min-width: 900px)';
